import { attributes, AttributesMixin, define, Model } from "@type-r/models";
import { restfulIO } from "./endpoint";


export interface DigitizedAssetMasterCount extends AttributesMixin<typeof DigitizedAssetMasterCount> { }
@define
export class DigitizedAssetMasterCount extends Model {
    static endpoint = restfulIO('/api/v1/assetmaster/assets/asset-count/');

    static attributes = {
        count: Number
    };
}
